import React from 'react';
import {
    OutlinedInput,
    InputAdornment,
    FormHelperText,
    FormControl,
    Tooltip,
    Zoom,
} from '@material-ui/core';

import helpSvg from '../assets/img/help.svg';
import ErrorIcon from '@material-ui/icons/Error';
import useStyles from '../styles/styles';

type PeInputProps = {
    readonly input?: any;
    readonly type: string;
    readonly placeholder?: string;
    readonly id: string;
    readonly label: string;
    readonly isShowLabel?: boolean;
    readonly adornment?: string;
    readonly fullWidth?: boolean;
    readonly required?: boolean;
    readonly disabled?: boolean;
    readonly toolTip?: boolean;
    readonly meta?: {
        touched: any;
        error: any;
    };
};

const PeInput: React.FC<PeInputProps> = ({
    isShowLabel,
    id,
    input,
    required,
    label,
    type,
    placeholder,
    adornment,
    fullWidth,
    meta,
    disabled,
    toolTip,
}) => {
    const classes = useStyles();

    const showLabel =
        typeof isShowLabel !== 'undefined' ? Boolean(isShowLabel) : true;

    const createMask = (str: string) => {
        return str.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
    };

    const destroyMask = (str: string) => {
        return str.replace(/\D/g, '').substring(0, 10);
    };

    const getMaskValue = () => {
        if (id !== 'phone_number') {
            return input.value;
        } else {
            return createMask(destroyMask(input.value));
        }
    };

    return (
        <div className={toolTip ? classes.control : ''}>
            <FormControl error={Boolean(meta?.error)} variant="outlined" fullWidth={typeof fullWidth !== 'undefined' ? fullWidth : true}>
                <div className={classes.labelArea}>
                    {showLabel && (
                        <h3 className={classes.label}>
                            {required && (<span className={classes.required}>*</span>)}{' '}
                            {label}
                        </h3>
                    )}
                    {toolTip && (
                        <Tooltip title={toolTip} TransitionComponent={Zoom} placement="right-end" arrow>
                            <img src={helpSvg} alt="help" className={classes.iconHelp} />
                        </Tooltip>
                    )}
                </div>
                {/* {showLabel && <h3 className={classes.label}>{required && <span className={classes.required}>*</span>}&nbsp;{label}</h3>} */}
                <OutlinedInput
                    className={classes.input}
                    inputProps={{
                        ...input,
                        maxLength: type === 'tel' ? 12 : null,
                        value: getMaskValue(),
                    }}
                    id={id}
                    placeholder={type === 'tel' ? '04xx xxx xxx' : placeholder}
                    type={type}
                    endAdornment={
                        adornment && (
                            <InputAdornment position="end">
                                {adornment}
                            </InputAdornment>
                        )
                    }
                    disabled={disabled}
                    // value={getMaskValue()}
                    // {...props.input}
                />
                {/* {props.type === "tel" && getMaskValue()} */}
                {meta?.error && (
                    <FormHelperText
                        className={classes.helpText}
                        component="div"
                    >
                        <ErrorIcon fontSize="small" />
                        <p style={{ margin: 0, padding: 0 }}>
                            {' '}{meta?.error}
                        </p>
                    </FormHelperText>
                )}
            </FormControl>
        </div>
    );
};

export default PeInput;
